<script>
  import { addEllipses, getAfterTimeStampStrapi } from "../../../utils";
  import { link } from "svelte-spa-router";
  import NETWORKS from "../../../constants/network";
  import {RAISE_TYPES} from "../../../constants/constants";
  import {
    projectDetail,
  } from '../../../store'

  export let projectID;
  export let isCopied = false;
  export let projectName = "";
  export let saleAddress = "";
  export let startTime = "";
  export let endTime = "";
  export let status = "";
  export let saleType;
  export let draft, chainID;

  const copyCode = () => {
    navigator.clipboard.writeText(saleAddress);
    isCopied = true
    setTimeout(()=>{
      isCopied = false
    },1000)
  
  };
</script>

<tr>
  <td id="name-{projectName}">{projectName}</td>

  <td id="address-{projectName}">
    {#if saleAddress}
      {addEllipses(saleAddress)}
      <span class="copy-wrap">
      <img
        class="copy-sale"
        on:click={copyCode}
        src="./images/copy.svg"
        alt="copy"
      />
      {#if isCopied}
        <small>Copied!</small>
      {/if}
      </span>
    {:else}-{/if}
  </td>
  <td id="start-time-{projectName}">
    {#if startTime}
      {getAfterTimeStampStrapi(
        new Date(startTime).getTime(),
        "MM-DD-YYYY HH:mm"
      )}
    {:else}-{/if}
  </td>
  <td id="end-time-{projectName}">
    {#if endTime}
      {getAfterTimeStampStrapi(new Date(endTime).getTime(), "MM-DD-YYYY HH:mm")}
    {:else}-{/if}
  </td>
  <td id="raise-type-{projectName}">
    <span>
      {RAISE_TYPES[saleType] ?? ""}
    </span>
  </td>
  <td id="chain-{projectName}">
    <span class="network-chain">
      {#if NETWORKS[chainID]}
        <img src={NETWORKS[chainID]?.iconUrl} alt="" />
        {NETWORKS[chainID]?.name}
      {/if}
    </span>
  </td>
  <td id="status-{projectName}">
    <span class={`table-status ${status.replaceAll(" ", "").toLowerCase()}`}>
      {status}
    </span>
  </td>

  <td>
    {#if !draft}
      <div class="table-drop flex">
        <a
          id="preview-{projectName}"
          title="Preview"
          href={`/project-details/${projectID}`}
          use:link
        >
          <img
          on:click={()=>{
            projectDetail.set({});
          }}
            class="table-drop-down"
            src="./images/preview.svg"
            alt="preview"
          />
        </a>
        <a
          id="sales-{projectName}"
          title="Sales"
          href={`#/sale-detail/${projectID}`}
          use:link
          on:click
        >
          <img class="table-drop-down" src="./images/sale.svg" alt="sale" />
        </a>
      </div>
    {:else}
      <div class="table-drop flex">
        <a
          id="edit-{projectName}"
          title="Edit"
          href={`#/permissionless/${projectID}`}
          use:link
          on:click
        >
          <img
            class="table-drop-down"
            src="./images/edit.svg"
            alt="edit"
            on:click
          />
        </a>
      </div>
    {/if}
  </td>
</tr>
